(() => {
  'use strict';

  if (window.__xifunDarkHeaderLoaded) return;
  window.__xifunDarkHeaderLoaded = true;

  let activeSections = 0;
  let ticking = false;

  const update = () => {
    document.body.classList.toggle('xifun-header-condensed', window.scrollY > 48);
    ticking = false;
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  const enable = () => {
    activeSections += 1;
    document.body.classList.add('xifun-dark-home');
    if (activeSections === 1) {
      window.addEventListener('scroll', onScroll, { passive: true });
      update();
    }
  };

  const disable = () => {
    activeSections = Math.max(0, activeSections - 1);
    if (activeSections > 0) return;
    window.removeEventListener('scroll', onScroll);
    document.body.classList.remove('xifun-dark-home', 'xifun-header-condensed');
  };

  document.querySelectorAll('[data-xifun-dark-hero]').forEach(enable);
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches?.('[data-xifun-dark-hero]')) enable();
  });
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.matches?.('[data-xifun-dark-hero]')) disable();
  });
})();
